<template>
  <div style="width:100%;height:100%">
    <h1 class="chart-top-title">舆情监控<span class="chart-modal-flag" @click="dialogVisible = true"><i class="el-icon-view"></i></span></h1>
    <div
      class="chart-wrapper"
      ref="chart"
      style="height:364px;width:100%"
    >
    </div>
    <el-dialog :visible.sync="dialogVisible" :append-to-body="true" :fullscreen="true" center :modal="mask">
      <img style="width: 100%;height: 100%;" src="../../../static/imgs/lyrical.jpg" alt="">
    </el-dialog>
  </div>
</template>

<script>
import { vueBus } from '../../assets/js/common/vueBus'
export default {
  name: 'plusLineChart',
  props: {
    echartsData: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      dialogVisible: false,
      mask: false,
      anima: '',
      color: this.$chartColor || ['006497'],
      axisLabelColor: '#ccd6e0',
      axisLineColor: '#20B1CC',
      xData: [
        '0',
        '0:30',
        '1:00',
        '1:30',
        '2:00',
        '2:30',
        '3:00',
        '3:30',
        '4:00',
        '4:30',
        '5:00',
        '5:30',
        '6:00',
        '6:30',
        '7:00',
        '7:30',
        '8:00',
        '8:30',
        '9:00',
        '9:30',
        '10:00',
        '10:30',
        '11:00',
        '11:30',
        '12:00',
        '12:30',
        '13:00',
        '13:30',
        '14:00',
        '14:30',
        '15:00',
        '15:30',
        '16:00',
        '16:30',
        '17:00',
        '17:30',
        '18:00',
        '18:30',
        '19:00',
        '19:30',
        '20:00',
        '20:30',
        '21:00',
        '21:30',
        '22:00',
        '22:30',
        '23:00',
        '23:30',
        '23:59'
      ],
      dataArr: [
        20,
        21,
        22,
        23,
        68,
        18,
        23,
        28,
        33,
        38,
        43,
        72,
        50,
        48,
        46,
        44,
        42,
        40,
        21,
        71,
        32,
        30,
        28,
        26,
        24,
        22,
        80,
        40,
        30,
        26,
        22,
        18,
        14,
        49,
        40,
        35,
        52,
        50,
        22,
        20,
        18,
        16,
        49,
        51,
        33,
        21,
        20,
        17,
        15
      ]
    }
  },
  watch: {
    echartsData: {
      handler: function(val, oldVal) {
        this.initChart()
      },
      deep: true //增加deep 观察对象的子对象变化
    },
    anima: {
      handler: function(val, oldVal) {
        if (val == 'animateStart') {
          this.myChart = this.$echarts.init(this.$refs.chart)
          this.initChart()
        }
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      let me = this
      vueBus.$on('imgOnload', v => {
        me.anima = v
      })
    })
  },
  methods: {
    handleClose(done) {
      done();
    },
    initChart() {
      // var base = +new Date(2000, 1, 1)
      // var oneDay = 24 * 3600 * 1000 * 30
      // var date = []
      // var data = [Math.random() * 300]
      // var now = '';
      // var num = 0;
      // for (var i = 1; i < 1200; i++) {
      //   if (i % 20 === 0) {
      //     num++;
      //     now = base + oneDay * num;
      //     date.push(new Date(now).getFullYear())
      //     data.push(Math.random() * 200)
      //   }
      // }
      // data[12] = 175;
      // data[35] = 140;
      // data[50] = 200;
      let option = {
        tooltip: {
          trigger: 'axis',
          position: function(pt) {
            return [pt[0], '10%']
          }
        },
        xAxis: [
          {
          type: 'category',
          boundaryGap: false,
          data: this.xData,
          position: 'bottom',
          axisLabel: {
            color: this.axisLabelColor,
            // interval: function(index) {
            //   return index % 12 === 0 
            // }
          },
          axisLine: {
            onZero: false,
            lineStyle: {
              width: 2,
              color: this.axisLineColor
            }
          },
          axisTick: {show: false},
          splitLine: {
            show: true,
            interval: 5,
            lineStyle: {
              type: 'dashed',
              color: this.axisLineColor
            }
          }
        },
        {
          type: 'category',
          position: 'top',
          axisLine: {
            onZero: false,
            lineStyle: {
              width: 2,
              color: this.axisLineColor
            }
          }
        }
        ],
        yAxis: [
          {
          type: 'value',
          max: 100,
          boundaryGap: [0, '100%'],
          position: 'left',
          axisLine: {
            lineStyle: {
              width: 2,
              color: this.axisLineColor
            }
          },
          axisLabel: {
            color: this.axisLabelColor,
            formatter: '{value}%'
          },
          axisTick: {
            show: false
          },
          splitLine: {
            show: true,
            lineStyle: {
              type: 'dashed',
              color: this.axisLineColor
            }
          }
        },
        {
          position: 'right',
          axisLine: {
            lineStyle: {
              width: 2,
              color: this.axisLineColor
            }
          }
        }
        ],
        grid: {
          top: 20,
          bottom: 50,
          left: 50,
          right: 50
        },
        series: [
          {
            name: '',
            type: 'line',
            smooth: false,
            symbol: 'none',
            sampling: 'average',
            itemStyle: {
              normal: {
                color: 'rgb(155, 193, 76)'
              }
            },
            areaStyle: {
              normal: {
                color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  {
                    offset: 0,
                    color: this.color[0]
                  },
                  {
                    offset: 1,
                    color: '#000'
                  }
                ])
              }
            },
            markPoint: {
              symbol: 'circle',
              symbolSize: [25, 25],
              data: [
                {
                  value: '左氧氟沙星注射液',
                  coord: [11, 72],
                  itemStyle: {
                    color: 'rgba(211,77,77,.8)'
                  },
                  label: {
                    show: true,
                    position: 'top',
                    distance: 10,
                    fontSize: 24,
                    color: '#fff',
                  }
                },
                
                {
                  value: '狂犬疫苗',
                  coord: [36, 52],
                  itemStyle: {
                    color: 'rgba(0, 154, 277,.8)'
                  },
                  label: {
                    show: true,
                    position: 'top',
                    distance: 0,
                    fontSize: 24,
                    color: '#fff'
                  }
                },
                {
                  value: '清开灵注射液',
                  coord: [26, 80],
                  itemStyle: {
                    color: 'rgba(255,235,0,.7)'
                  },
                  label: {
                    show: true,
                    position: 'top',
                    distance: 10,
                    fontSize: 24,
                    color: '#fff'
                  }
                }
              ]
            },
            data: this.dataArr
          }
        ]
      }
      this.myChart.on('click', params => {
        this.$emit('handleCharts', params.name)
      })
      this.myChart.setOption(option)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.chart-modal-flag {
  line-height: 64px;
  font-size: 40px;
  font-weight: 700;
  color: #fff;
  right: 25px;
  position: absolute;
  i {
    color: #fff;
    cursor: pointer;
    font-weight: 900;
  }
}

.chart-top-title {
  height: 76px;
  line-height: 95px;
  font-size: 40px;
  font-weight: 700;
  color: #65ecc3;
  text-align: center;
  letter-spacing: 2px;
  position: relative;
  .chart-select {
    position: absolute;
    width: 175px;
    height: 45px;
    line-height: 45px;
    border: 2px solid #046292;
    left: 28px;
    top: 26px;
    border-radius: 8px;
    font-weight: 400;
    color: #fff;
    font-size: 20px;
    text-align: left;
    padding-left: 20px;
    -webkit-border-radius: 8px;
    -moz-border-radius: 8px;
    -ms-border-radius: 8px;
    -o-border-radius: 8px;
  }
  .select-icon {
    position: absolute;
    font-size: 26px;
    right: 10px;
    top: 3px;
  }
 }
 .remarkes {
  height: 40px;
  line-height: 24px;
  font-size: 20px;
  color: #acb4bc;
  padding-left: 50px;
}
</style>



// WEBPACK FOOTER //
// src/components/echarts/plusLineChart.vue